import { SET_CONTACT_US_FINISH } from "./types.js";
import * as Service from "./../apiService/service.js";

export const submitContactUs = (payload) => async (dispatch) => {
    dispatch({
        type: SET_CONTACT_US_FINISH,
        payload: false,
    });
    var data = await Service.sendContactUs(payload);
    dispatch({
        type: SET_CONTACT_US_FINISH,
        payload: true,
    });
};
